import { CompanyStatuses } from '@components/business/companyStatuses/CompanyStatuses'
import Page from '@components/Page/Page'
import { TableUrlParams, useTableUrlSync } from '@hooks/useTableUrlSync'
import { BusinessProfileStatus as BusinessProfileStatusModel } from '@models/business/BusinessProfileStatus'
import {
  getBusinessProfileStatuses,
  selectBusinessProfileStatuses,
  setBusinessProfileStatusQuery,
} from '@store/business/BusinessProfileStatusReducer'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { SBTable, TableParams } from '@supplement-bacon/sb-table-filters'
import { useSBRM } from '@supplement-bacon/sbrm-react'
import { Permission } from '@utils/permissions'
import type { TableColumnsType } from 'antd'
import { useEffect } from 'react'

const BusinessProfilStatusesPage = () => {
  const { isOpen } = useSBRM()

  const dispatch = useAppDispatch()
  const businessProfileStatuses = useAppSelector(
    selectBusinessProfileStatuses()
  )
  const { query, isLoading } = useAppSelector(
    (state) => state.businessProfileStatus
  )

  const columns: TableColumnsType<BusinessProfileStatusModel> = [
    {
      title: 'Avatar',
      render: (record: BusinessProfileStatusModel) => (
        <CompanyStatuses.StatusTag model={record} />
      ),
    },
  ]

  const fetchBusinessProfileStatuses = (params: TableUrlParams) => {
    const newQuery: TableParams = {
      ...query,
      pagination: {
        ...query.pagination,
        current: params.page,
        pageSize: params.pageSize,
      },
    }

    dispatch(setBusinessProfileStatusQuery(newQuery))
    dispatch(getBusinessProfileStatuses(newQuery))
  }

  const { handleTableChange, params } =
    useTableUrlSync<BusinessProfileStatusModel>({
      onParamsChange: fetchBusinessProfileStatuses,
    })

  useEffect(() => {
    if (isOpen) return

    fetchBusinessProfileStatuses(params)
  }, [isOpen])

  return (
    <Page
      permissions={Permission.manageBusiness}
      pageTitle={{
        title: 'Employee statuses',
        level: 4,
      }}
    >
      <SBTable
        columns={columns}
        dataSource={businessProfileStatuses}
        loading={isLoading}
        onChange={handleTableChange}
        pagination={query.pagination}
      />
    </Page>
  )
}

export default BusinessProfilStatusesPage
